import {Component} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'data-deletion-instructions',
  templateUrl: './data-deletion-instructions.component.html',
  styleUrl: './data-deletion-instructions.component.css'
})
export class DataDeletionInstructionsComponent {
}
